import { Badge as AntdBadge } from 'antd';
import styled from 'styled-components';
import { Caption01, Text02 } from 'components/styles';

export const Pane = styled.div`
  border-left: 1px solid var(--gray-10);
  padding-top: var(--spacing-05);
  height: 100%;
  overflow: auto;
  .ant-tabs-content-holder .ant-tabs,
  .ant-tabs-tabpane,
  .ant-tabs-content,
  .ant-tabs {
    height: 100%;
    overflow: auto;
  }
  .ant-tabs-nav-list {
    width: 98%;
  }
  .ant-tabs-tab {
    flex-basis: 50%;
    flex: 1;
  }
`;

export const Badge = styled(AntdBadge)`
  .ant-badge-status-text {
    font-size: var(--font-size-sm);
  }
`;

export const ConfigurationTab = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-width: 150px;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  width: 100%;
`;

export const Header = styled.div`
  flex: 1;
  font-size: var(--heading-5-size);
  font-weight: var(--heading-5-weight);
  line-height: var(--heading-3-line-height);
`;

export const Actions = styled.div`
  margin-top: -24px;
  display: flex;
  align-items: center;
`;

export const LastSavedText = styled.span`
  ${Caption01};
  ${Text02};

  margin-right: var(--layout-02);
`;
